import { namespace } from './namespace';

export const UPDATE_RESPONSE = namespace + '/UPDATE_RESPONSE';
export const SAVE_RESPONSE = namespace + '/SAVE_RESPONSE';
